"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimePeriod;
(function (TimePeriod) {
    TimePeriod["ALL_TIME"] = "ALL_TIME";
    TimePeriod["CURRENT_MONTH"] = "CURRENT_MONTH";
    TimePeriod["CURRENT_WEEK"] = "CURRENT_WEEK";
    TimePeriod["LAST_MONTH"] = "LAST_MONTH";
    TimePeriod["LAST_WEEK"] = "LAST_WEEK";
    TimePeriod["TODAY"] = "TODAY";
    TimePeriod["YESTERDAY"] = "YESTERDAY";
    TimePeriod["CUSTOM"] = "CUSTOM";
})(TimePeriod || (TimePeriod = {}));
exports.default = TimePeriod;
